import { PARAM_SUB_PAGE, EXCLUSION_SUB_PAGES } from '@/components/Lobby/enum.js'

export default function i18nHead(nuxtI18n, { route = '' } = {}) {
  const i18nHead = nuxtI18n

  i18nHead.link = i18nHead.link.map((link) => {
    if (link.rel === 'alternate' && link.hreflang) {
      // Преобразуем hreflang в нужный формат, например, "uk-UA"
      if (link.hreflang === 'uk') {
        link.hreflang = 'uk-UA'
      }
      else if (link.hreflang === 'ru') {
        link.hreflang = 'ru-UA'
      }
    }
    link.href = link.href.endsWith('/') ? link.href.slice(0, -1) : link.href

    if (link.rel === 'canonical' && !!route && !!route?.params[PARAM_SUB_PAGE]) {
      const isExclusionSubPage = EXCLUSION_SUB_PAGES.includes(route.params[PARAM_SUB_PAGE])

      if (isExclusionSubPage) {
        const fullPath = link.href
        const subSection = route.params[PARAM_SUB_PAGE]
        link.href = fullPath.replace(`/${subSection}`, '')
      }
    }
    return link
  })

  return {
    ...i18nHead,
    // Дополнительные мета-теги, если нужно
  }
}
